/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";

/** Common Components */
import MolGrid, { Column } from "@moltech/molui/molgrid";
import ToastService from "../../../services/toastService/ToastService";
import CardSection from "../../../components/ui/card/CardSection";
import Buttons from "../../../components/ui/button/Buttons";
import TextArea from "../../../components/finalForms/ui/inputs/textArea/TextArea";
import { AppIcons } from "../../../data/appIcons";
import CustomCenterModel from "../../../components/ui/customCenterModel/CustomCenterModel";


/** Utilities */
import { getCookie } from "../../../utils/Cookies/CookieHandler";

/** RTK Query */
import { useAddnoteMutation, useDeleteNoteMutation, useGetAllnotesMutation } from "../../../app/services/commonAPI";
import PropTypes from "prop-types";
import formatDate from "../../../components/finalMolGrid/libs/formatDate";

const Notes = (props) => {

    const { plOwnerKey, plOwnerTypeKey } = props;

    const gridRef = useRef();
    const [isModelOpen, setIsModelOpen] = useState(false);
    const [gridData, setGridData] = useState([]);
    const [noteData, setNoteData] = useState("");
    const cookie = getCookie("AuthUser");
    const userID = cookie?.user?.lUserKey;

    //api Calling
    const [getAllnotes, {
        isSuccess: isAllnotesFetched,
        data: AllnotesData
    }] = useGetAllnotesMutation();

    const [deleteNote, {
        isSuccess: isdeleteNoteDeleted,
        data: deleteNoteData
    }] = useDeleteNoteMutation();

    const [addnote, {
        isSuccess: isaddnoteAdded,
        data: addnoteData,
    },] = useAddnoteMutation();

    useEffect(() => {
        if (isdeleteNoteDeleted && deleteNoteData) {
            if (deleteNoteData) {
                ToastService.success(deleteNoteData?.errorMessage);
            }
            else {
                ToastService.error("Something went wrong");
            }
        }
    }, [isdeleteNoteDeleted, deleteNoteData]);

    useEffect(() => {
        if (isAllnotesFetched && AllnotesData) {
            setGridData(AllnotesData);
        }
    }, [isAllnotesFetched, AllnotesData]);

    useEffect(() => {
        if (isaddnoteAdded && addnoteData) {
            if (addnoteData) {
                ToastService.success(addnoteData?.errorMessage);
                handleCloseModel();
            }
        }
    }, [isaddnoteAdded, addnoteData]);

    const handleAddClick = () => {
        setIsModelOpen(true);
    };

    const getCtxMenuItems = (row) => {
        if (!row) return [];
        return [
            {
                label: "Delete",
                command: () => {
                    if (row?.lNoteKey) {
                        deleteNote(row?.lNoteKey);
                    }
                }
            }
        ];
    };

    const handleCloseModel = () => {
        setIsModelOpen(false);
        setNoteData("");
    };

    useEffect(() => {
        getAllnotes({ plOwnerKey: plOwnerKey, plOwnerTypeKey: plOwnerTypeKey });
    }, [plOwnerKey, isdeleteNoteDeleted, isaddnoteAdded]);

    const handleSaveClick = () => {
        const req = {
            plNoteKey: 0,
            plOwnerTypeKey: plOwnerTypeKey,
            plOwnerKey: plOwnerKey,
            plUserKey: userID,
            pdtNoteDate: new Date().toISOString(),
            psNote: noteData
        }
        addnote(req);
    }

    const headerContent = () => {
        return (
            <div className="d-flex justify-content-end gap-3 export-icon">
                <Buttons
                    buttonText="Add Note"
                    onClick={handleAddClick}
                    buttonTypeClassName="btn blue-btn"
                />
            </div>
        );
    };
    return (
            <div className="row gap-4">
                <div className="scrollable-grid col-12 note-grid-table">
                    <CardSection
                        cardTitle={`Notes`}
                        customHeader={true}
                        headerContent={headerContent()}
                    >
                        <MolGrid
                            ref={gridRef}
                            value={gridData}
                            grouping
                            expandableRowGroups={true}
                            paginator={false}
                            scrollable
                            scrollHeight="flex"
                            filterDisplay="row"
                            sortMode="single"
                            showGridlines
                            resizableColumns
                            ctxMenuItems={getCtxMenuItems}
                        >
                            <Column field="dtNoteDate" header="Date" colType="datetime" 
                             body={(row) => formatDate(row.dtNoteDate, "MM/DD/YYYY hh:mm:ss A")}
                             bodyStyle={{ textAlign: "Center" }}  grouping sortable />
                            <Column field="userName" header="User" bodyStyle={{ textAlign: "Center" }} grouping sortable  />
                            <Column field="sNote" header="Note" grouping sortable />
                        </MolGrid>
                    </CardSection>
                </div>
                <CustomCenterModel
                    isOpen={isModelOpen}
                    useCustomBg={true}
                    modalTitle={"Add Note"}
                    contentClass="content-50"
                    onClose={handleCloseModel}
                    modalTitleIcon={AppIcons.AddIcon}
                >
                    <TextArea
                        name="Note"
                        value={noteData}
                        onChange={(val) => setNoteData(val)}
                    />
                    <div className="d-flex justify-content-end gap-3 export-icon">
                        <Buttons
                            buttonText="Save"
                            onClick={handleSaveClick}
                            buttonTypeClassName="btn blue-btn"
                            isDisable={noteData.trim() === ""}
                        />
                        <Buttons
                            buttonText="Cancel"
                            onClick={handleCloseModel}
                            buttonTypeClassName="btn blue-btn"
                        />
                    </div>
                </CustomCenterModel>
            </div>
    );
};
export default Notes;

Notes.propTypes = {
    plOwnerKey: PropTypes.number,
    plOwnerTypeKey: PropTypes.number
};
